// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18zr1b66{padding-inline:var(--ds-space-050,4px)}\n._195gr5cr{margin-inline:var(--ds-space-negative-050,-4px)}\n._1rjcpxbi{padding-block:var(--ds-space-200,1pc)}\n._94n5ze3t{bottom:var(--ds-space-0,0)}\n._bfhkvuon{background-color:var(--ds-surface,#fff)}\n._kqsw1if8{position:sticky}", ""]);
// Exports
module.exports = exports;
